import { useState, useEffect, useCallback } from "react";
import { Table } from "antd";
import { fetchDiscountCodeRedemptions } from "services/discountCodes.service";
import { renderErrorNotifications } from "helpers/error.helpers";
import {
  CODES_PAGE_SIZE,
  formatIst,
  formatRupees,
} from "../commons/discountCodes.helpers";
import { CODES_COPY } from "../commons/discountCodes.copy";

const columns = [
  {
    title: "Customer",
    dataIndex: "customer_name",
    key: "customer_name",
    render: (v) => v || "—",
  },
  { title: "Event", dataIndex: "event_name", key: "event_name" },
  {
    title: "Membership",
    dataIndex: "membership_tier",
    key: "membership_tier",
    render: (v) => v || CODES_COPY.membershipNone,
  },
  { title: "Tickets", dataIndex: "tickets", key: "tickets", align: "center" },
  {
    title: "Code discount",
    dataIndex: "code_discount",
    key: "code_discount",
    align: "right",
    render: (v) => formatRupees(v),
  },
  {
    title: "Paid",
    dataIndex: "paid_amount",
    key: "paid_amount",
    align: "right",
    render: (v) => formatRupees(v),
  },
  {
    title: "When",
    dataIndex: "created_at",
    key: "created_at",
    render: (v) => formatIst(v, "D MMM, h:mm a"),
  },
];

/** Redemptions of the chosen run (D-7). */
function RedemptionsTab({ codeId, runId }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ current: 1, total: 0 });

  const load = useCallback(
    async (page) => {
      setLoading(true);
      const { data: envelope, errors } = await fetchDiscountCodeRedemptions(
        codeId,
        {
          current_page: page,
          page_size: CODES_PAGE_SIZE,
          ...(runId && { run_id: runId }),
        }
      );
      setLoading(false);
      if (errors?.length) {
        renderErrorNotifications(errors);
        setRows([]);
        return;
      }
      setRows(Array.isArray(envelope?.data) ? envelope.data : []);
      setPagination({
        current: page,
        total: envelope?.meta?.pagination?.total_count ?? 0,
      });
    },
    [codeId, runId]
  );

  useEffect(() => {
    load(1);
  }, [load]);

  return (
    <Table
      rowKey={(r, i) => `${r.order_number ?? ""}-${i}`}
      columns={columns}
      dataSource={rows}
      loading={loading}
      size="small"
      scroll={{ x: 800 }}
      locale={{ emptyText: CODES_COPY.redemptionsEmpty }}
      pagination={{
        current: pagination.current,
        pageSize: CODES_PAGE_SIZE,
        total: pagination.total,
        showSizeChanger: false,
        placement: "bottomRight",
      }}
      onChange={(pag) => load(pag.current)}
    />
  );
}

export default RedemptionsTab;
